<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" style="padding: 1em;">
      <div class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription">
        <header class="modal-header" id="modalTitle">
            【 考生注意事項 】
            <el-row>
                <el-button type="success" @click="ok()" round>我已經看過注意事項並且同意</el-button>
                <el-button type="info" @click="$emit('close')" round>取消</el-button>
            </el-row>
        </header>
        <section class="modal-body" id="modalDescription">  
            <div class='well'
                style="display:inline-table; padding: 0.1875em; width: 100%;"
                v-html="(null == dataContent? '': dataContent.contText)"/>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'vConfirm',
  props: [
    'sysId',
    'data'
  ],
  data () {
    return {
      dataContent: null
    }
  },
  methods: {
    ok () {
        let vm = this
        vm.$http.get('./WebApi/Apply/GetConfirmData/'.concat(this.data.dId))
                .then((success) =>{                            
                    if (success.data) {
                        vm.$message({
                                        message: '恭喜您,存檔成功',
                                        type: 'success'
                                      });
                        vm.$store.dispatch('setOptionFlag', true);
                        vm.$emit('close');
                    }
                })
                .catch(function (error) {
                    vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                    offset: 150
                               });
                    vm.$emit('close');
                });
    },
  },
  created () {
    console.log('======created vConfirm =====')
    var vm = this
    this.$store.dispatch('setOptionFlag', false);
    this.$http
        .get("./WebApi/Setting/GetFormatData/".concat(this.sysId).concat("/1/3"))
        .then(function(response) {
          if (response.data != null) {
            vm.dataContent = response.data
          } else {
            vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                offset: 150
                            });
            vm.$emit('close');
           }
        })
        .catch(function (error) {
            vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
            vm.$emit('close');
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pull-right {
  float: right;
}
.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
  box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
}
.modal-backdrop 
{ 
    position: fixed; 
    top: 0; 
    right: 0; 
    bottom: 0; 
    left: 0; 
    background-color: rgba(0,0,0,.3); 
    display: flex; 
    justify-content: center; 
    align-items: center; 
} 
.modal { 
    background-color: #fff;  
    transform: translate(0,0); 
    z-index: 1050; 
    width: 900px;
    display: block; 
    flex-direction: column; 
    position: relative;  
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #999;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 6px;
    outline: 0;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
} 
.modal-header, .modal-footer { 
    padding: 15px; 
    display: flex; 
} 
.modal-header { 
    border-bottom: 1px solid #eee; 
    color: #4aae9b; 
    justify-content: space-between; 
    text-align: center;
} 
.modal-footer { 
    border-top: 1px solid #eee; 
    justify-content: flex-end; 
} 
.modal-body { 
    position: relative; 
    padding: 20px 10px; } 
    .btn-close { 
    border: none 0; 
    font-size: 20px; 
    padding: 20px; 
    cursor: pointer; 
    font-weight: 
    bold; color: #4aae9b; 
    background-color: transparent; 
} 
</style>


// WEBPACK FOOTER //
// src/components/ConfirmView.vue